<template>
<div>
    <section>
        <b-tabs v-model="$root.env.view.tabArrangement" position="is-centered" type="is-toggle-rounded">
            <b-tab-item label="Allgemein" icon="calendar-check">
                <General />
            </b-tab-item>
            <b-tab-item label="Landingpage" icon="desktop-alt">
                <Landingpage v-if="typeof $root.event.landingpage !== 'undefined' && typeof $root.settings.firms !== 'undefined' && $root.settings.firms.length > 0"/>
            </b-tab-item>
            <b-tab-item label="Gästeinfos" icon="users">
                <Guests />
            </b-tab-item>
            <b-tab-item label="Locations" icon="map-marked-alt">
                <Locations />
            </b-tab-item>
            <b-tab-item label="Workshops" icon="users-class">
                <Workshops />
            </b-tab-item>
            <b-tab-item label="Transfers" icon="bus-alt">
                <Transfers />
            </b-tab-item>
            <b-tab-item label="Unterbringung" icon="bed">
                <Accommodations />
            </b-tab-item>
        </b-tabs>
    </section>

</div>
</template>

<script>
import General from '@/components/Events/SubviewArrangement/General.vue'
import Landingpage from '@/components/Events/SubviewArrangement/Landingpage.vue'
import Workshops from '@/components/Events/SubviewArrangement/Workshops.vue'
import Transfers from '@/components/Events/SubviewArrangement/Transfers.vue'
import Locations from '@/components/Events/SubviewArrangement/Locations.vue'
import Accommodations from '@/components/Events/SubviewArrangement/Accommodations.vue'
import Guests from '@/components/Events/SubviewArrangement/Guests.vue'

export default {
    name: 'Arrangement',
    components: {
        General,
        Landingpage,
        Workshops,
        Locations,
        Accommodations,
        Guests,
        Transfers
    },
    props: {

    },
    data() {
        return {

        }
    },
    methods: {
        update(id = this.$route.params.id) {
            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}
.tab-item{
    margin-top: 25px;
}
</style>
